import {queries} from '@/shared/integrations/zero'
import {TradeName} from '@cypro/engine/schema'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetTradeName(id: string | undefined | null) {
  const [tradeName, meta] = useQuery(queries.products.getTradeNameById(id || ''))
  return [tradeName as unknown as TradeName, meta] as const
}

export function useSuspenseGetTradeName(id: string | undefined | null) {
  const [tradeName, meta] = useSuspenseQuery(queries.products.getTradeNameById(id || ''))
  return [tradeName as unknown as TradeName, meta] as const
}
